import React from "react";

import { Icon, IconButton } from "../../../components/ui";

const CollapseButton = ({ isOpen, setIsOpen }) => (
  <IconButton
    variant="ghost"
    size="sm"
    label={isOpen ? "Hide earlier prices" : "Show earlier prices"}
    aria-expanded={isOpen}
    data-btn="price-toggle"
    onClick={() => setIsOpen(!isOpen)}
  >
    <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} size="sm" />
  </IconButton>
);

export default CollapseButton;
